var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGethelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.55947 9.32219C1.35914 9.96236 0.718973 11.4027 1.11908 12.9232C1.43917 14.0435 2.39942 14.9237 3.51972 15.1638C3.67977 15.1638 3.83981 15.2438 3.99985 15.2438C4.80007 15.2438 5.44024 14.4436 5.28019 13.6433L4.47998 10.1224C4.23992 9.24217 3.27966 8.84206 2.55947 9.32219Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4427 9.32216C16.643 9.96233 17.2832 11.4027 16.8831 12.9231C16.563 14.0434 15.6027 14.9237 14.4824 15.1637C14.3224 15.1637 14.1623 15.2437 14.0023 15.2437C13.2021 15.2437 12.5619 14.4435 12.722 13.6433L13.5222 10.1224C13.7622 9.24214 14.7225 8.84203 15.4427 9.32216Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.7638 9.56226V7.80179C15.7638 4.04078 12.723 0.999969 8.96198 0.999969C5.20097 0.999969 2.16016 4.04078 2.16016 7.80179V9.48224",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.56055 17.6445C10.7211 17.6445 12.2415 18.1246 13.7619 15.2439",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGethelp);
export default __webpack_public_path__ + "static/media/gethelp.aadfca0332175b52e71738a651585079.svg";
export { ForwardRef as ReactComponent };